var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 10H27.999V22H19.999V10Z",
    fill: "none",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 35L12.0001 44H11.999H35.999L31.0001 35",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.999 22V5C33.999 4.44772 33.5513 4 32.999 4H14.999C14.4467 4 13.999 4.44772 13.999 5V22",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07992 22.364C6.0384 22.1772 6.18056 22 6.37194 22H41.6261C41.8175 22 41.9596 22.1772 41.9181 22.3641V22.3641C40.6941 27.8723 37.2835 32.8158 31.9187 34.5641C29.4348 35.3735 26.6549 36 24.0001 36C21.3449 36 18.5642 35.3733 16.0797 34.5637C10.7148 32.8154 7.30395 27.8722 6.07992 22.364V22.364Z",
    stroke: "#333",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.61a9be701061c57325d0f8f4bdfe3fa8.svg";
export { ForwardRef as ReactComponent };